import { render, staticRenderFns } from "./SaveConfigPanel.vue?vue&type=template&id=3a63c5e4&"
import script from "./SaveConfigPanel.vue?vue&type=script&lang=ts&"
export * from "./SaveConfigPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SaveConfigPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports